import React from 'react';

import { Field, Form, FormSpy } from '@hrlogics/react-components/form';

import { DEFAULT_ID } from '@clearverify/constants';
import { noop } from '@clearverify/utils';

import { EmployerSimpleInfoFragment } from 'src/api';
import { AutocompleteField } from 'src/components/finalForm';
import { useFilter } from 'src/hooks/common';
import { AutocompleteFieldResult } from 'src/hooks/forms';

import { DashboardFilterFormField } from './constants';
import { DashboardFilterFormValues } from './types';

export type DashboardFilterProps = {
  autocompleteFieldProps: AutocompleteFieldResult<EmployerSimpleInfoFragment>;
};

export const DashboardFilter: React.FC<DashboardFilterProps> = ({ autocompleteFieldProps }) => {
  const { setFilter } = useFilter();

  const handleChange = React.useCallback(
    ({ values }: { values: DashboardFilterFormValues }) => {
      setFilter({
        employerIds: values.employers
          .filter(employer => employer.id !== DEFAULT_ID)
          .map(employer => employer.id),
      });
    },
    [setFilter],
  );

  return (
    <Form<DashboardFilterFormValues>
      onSubmit={noop}
      containerProps={{ sx: { width: 400 } }}
      initialValues={initialValues}
    >
      <Field
        name={DashboardFilterFormField.employers}
        label="Employers"
        entityName="Employers"
        fullWidth
        component={AutocompleteField}
        multiple
        multipleMode="all_option"
        {...autocompleteFieldProps}
      />
      <FormSpy<DashboardFilterFormValues> subscription={{ values: true }} onChange={handleChange} />
    </Form>
  );
};

const initialValues: DashboardFilterFormValues = {
  employers: [
    {
      id: DEFAULT_ID,
      setLiveAt: null,
      displayName: null,
      revenueShareSettingId: null,
    },
  ],
};
